import {
  API_ENDPOINT,
  useClientApiV2AccountsProfileQuery,
} from '../../resources/@types/accountSchema';
import useQueryOptionWithPathUserId from '../hooks/useQueryOptionWithPathUserId';

export function useClientApiAccountsProfileQuery(
  { withUserId }: { withUserId: boolean },
  options?: Parameters<typeof useClientApiV2AccountsProfileQuery>[0]['options'],
) {
  const queryForAdmin = useQueryOptionWithPathUserId(API_ENDPOINT.CLIENT_V2_ACCOUNTS_PROFILE);
  const option = withUserId
    ? {
        ...queryForAdmin,
        options,
      }
    : {
        queryKey: [API_ENDPOINT.CLIENT_V2_ACCOUNTS_PROFILE],
        url: API_ENDPOINT.CLIENT_V2_ACCOUNTS_PROFILE,
        options,
      };
  return useClientApiV2AccountsProfileQuery(option);
}

export const getUseClientApiAccountsProfileQueryKey = () => [
  API_ENDPOINT.CLIENT_V2_ACCOUNTS_PROFILE,
];

export const getUseClientApiAccountsProfileQueryKeyForAppShell = () => [
  '/client/api/v2/account/profiles',
];
